<template>
  <div>
    <div class="head">
      <div class="icon">
        <span class="el-icon-link"></span>
      </div>
      <h2>快速通道</h2>
      <h3>Fast &nbsp;&nbsp; track</h3>
    </div>
    <div class="content">
      <div v-for="item in FastTrackList">
        <img :src="item.imgUrl" />
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FastTrack",
  mounted() {},
  data() {
    return {
      FastTrackList: [
        {
          imgUrl: require("@/assets/imgs/fuwumenhu.jpg"),
          title: "服务门户"
        },
        {
          imgUrl: require("@/assets/imgs/jiaowux.jpg"),
          title: "教务"
        },
        {
          imgUrl: require("@/assets/imgs/tushuguan.jpg"),
          title: "图书馆"
        },

        {
          imgUrl: require("@/assets/imgs/zhaobiaogonggao.jpg"),
          title: "招标公告"
        },
        {
          imgUrl: require("@/assets/imgs/12345xx.png"),
          title: "校长信箱"
        },
        {
          imgUrl: require("@/assets/imgs/bx.png"),
          title: "后勤报修"
        },
        {
          imgUrl: require("@/assets/imgs/lq.png"),
          title: "学生录取信息查询"
        },
        {
          imgUrl: require("@/assets/imgs/yikatong.jpg"),
          title: "一卡通"
        },
        {
          imgUrl: require("@/assets/imgs/jw.png"),
          title: "教育平台"
        }
      ]
    };
  }
};
</script>
<style scoped>
.head {
  position: relative;
  height: 0.175rem;
  border-bottom: 1px solid #6510ad;
}
.head > .icon {
  left: 0;
  bottom: 5px;
}
.head > .icon > span {
  font-size: 0.145rem;
}
.head > h2 {
  position: absolute;
  left: 0.2rem;
  bottom: 10px;
  font-size: 0.125rem;
}
.head > h3 {
  position: absolute;
  left: 0.75rem;
  bottom: 10px;
  color: grey;
  font-size: 0.08rem;
}
.content {
  height: 1.5rem;
  display: grid;
  grid-template-columns: repeat(3, 0.75rem);
  grid-template-rows: repeat(2, 0.45rem);
  place-content: space-evenly;
}
.content > div {
  padding-top: 0.1rem;
  text-align: center;
  cursor: pointer;
  text-align: center;
}

.content > div > img {
  height: 0.2rem;
  width: 0.2rem;
}
.content > div > div {
  line-height: 30px;
}

@media screen and (max-width: 768px) {
  .content {
    height: 1.6rem;
    display: grid;
    grid-template-columns: repeat(3, 0.75rem);
    grid-template-rows: repeat(2, 0.55rem);
    place-content: space-evenly;
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FastTrack.vue